import { makeStyles } from '@mui/styles';

export default makeStyles((theme) => ({
  
    box: {
        display: "grid",
        // backgroundColor:"#fafafa",
        // borderRadius:"20px",
        
        padding:"10px",
        width:"80%",
       
      
        gridRowGap:"20px",
      
            gridTemplateColumns: "auto",
       
       
        justifyContent: "center",
        margin:"3% auto",
        alignItems: "center",
        color:"secondry",
        textAlign:"center"
        
      
    },




}));

